import { ASSISTANCE_TYPE } from './ASSISTANCE_TYPE';
import { BUSINESS_CLOSE_REASON } from './BUSINESS_CLOSE_REASON';
import { BUSINESS_EXPECTATIONS_NOT_MET } from './BUSINESS_EXPECTATIONS_NOT_MET';
import { BUSINESS_EXPECTATIONS } from './BUSINESS_EXPECTATIONS';
import { BUSINESS_INCOME_SOURCE } from './BUSINESS_INCOME_SOURCE';
import { BUSINESS_PERFORMANCE_EXPECTATIONS } from './BUSINESS_PERFORMANCE_EXPECTATIONS';
import { BUSINESS_PERFORMANCE } from './BUSINESS_PERFORMANCE';
import { CIC_EXPECTATIONS } from './CIC_EXPECTATIONS';
import { CIC_EXPERIENCE_COMPARED } from './CIC_EXPERIENCE_COMPARED';
import { CLIENT_CURRENT_STATUS } from './CLIENT_CURRENT_STATUS';
import { CLIENT_RELATIONSHIP_MANAGER } from './CLIENT_RELATIONSHIP_MANAGER';
import { ETHNICITY } from './ETHNICITY';
import { RACE_ETHNICITY } from './RACE_ETHNICITY';
import { GENDER_CHOICES } from './GENDER_CHOICES';
import { GOAL_COMPLETION } from './GOAL_COMPLETION';
import { HOUSEHOLD_INCOME_COMPARISON } from './HOUSEHOLD_INCOME_COMPARISON';
import { IMMEDIATE_PROBLEM_TYPE } from './IMMEDIATE_PROBLEM_TYPE';
import { LEVEL_OF_SATISFACTION } from './LEVEL_OF_SATISFACTION';
import { ORGANIZATION_LEGAL_STRUCTURE } from './ORGANIZATION_LEGAL_STRUCTURE';
import { RACE } from './RACE';
import { RE_APPLY_LENDER } from './RE_APPLY_LENDER';
import { REASON_FOR_LOAN_APPROVAL } from './REASON_FOR_LOAN_APPROVAL';
import { TYPE_OF_BUSINESS } from './TYPE_OF_BUSINESS';
import { YES_OR_NO, YES_OR_NO_BINARY } from './YES_OR_NO';
import { PRONOUNS } from './PRONOUNS';
import { STATUS_OF_DEMOGRAPHIC_DATA } from './STATUS_OF_DEMOGRAPHIC_DATA';
import { SURVEY_STATUS } from './SURVEY_STATUS';
import { LOAN_CORP } from './LOAN_CORP';
import { LOAN_PARTNER } from './LOAN_PARTNER';
import { SURVEY_TRIGGERS } from './SURVEY_TRIGGERS';

export default {
    ASSISTANCE_TYPE,
    BUSINESS_CLOSE_REASON,
    BUSINESS_EXPECTATIONS_NOT_MET,
    BUSINESS_EXPECTATIONS,
    BUSINESS_INCOME_SOURCE,
    BUSINESS_PERFORMANCE_EXPECTATIONS,
    BUSINESS_PERFORMANCE,
    CIC_EXPECTATIONS,
    CIC_EXPERIENCE_COMPARED,
    CLIENT_CURRENT_STATUS,
    CLIENT_RELATIONSHIP_MANAGER,
    ETHNICITY,
    RACE_ETHNICITY,
    GENDER_CHOICES,
    GOAL_COMPLETION,
    HOUSEHOLD_INCOME_COMPARISON,
    IMMEDIATE_PROBLEM_TYPE,
    LEVEL_OF_SATISFACTION,
    ORGANIZATION_LEGAL_STRUCTURE,
    RACE,
    RE_APPLY_LENDER,
    REASON_FOR_LOAN_APPROVAL,
    TYPE_OF_BUSINESS,
    YES_OR_NO,
    YES_OR_NO_BINARY,
    PRONOUNS,
    STATUS_OF_DEMOGRAPHIC_DATA,
    SURVEY_STATUS,
    LOAN_CORP,
    LOAN_PARTNER,
    SURVEY_TRIGGERS
} as Record<string, Record<string, { en: string; es: string }>>;
